module.exports = __webpack_public_path__ + "img/anquan3-4.5875e766.jpg";